import React from "react";

import { Icon, ICONS } from "../Icons";
import { StyledNotification } from "./styled";

export const Notification = ({
  onClose,
  icon = ICONS.lock,
  title = "Oops!",
  message = "We are facing a glitch at the moment, please try again later.",
  status = "",
  stakTrace = ""
}) => {
  return (
    <StyledNotification>
      <div className={"icon"}>
        <Icon name={icon} />
      </div>

      <div className={"errorMessage"}>
        <h6 className={"errorReason"}>{title}</h6>
        <p className={"errorDescription"}>{message}</p>
        {status && <p className={"errorDescription"}>{status}</p>}
        {stakTrace && <p className={"errorDescription"}>{stakTrace}</p>}
      </div>

      <div className={"closeIconWrapper"}>
        <Icon name={ICONS.close} className={"closeIcon"} onClick={onClose} />
      </div>
    </StyledNotification>
  );
};
